import type { ReactElement } from 'react'

import './styles.scss'

const VideoThumbnailSkeleton = (): ReactElement => {
  return (
    <div className="video-thumbnail-skeleton">
      <div className="video-thumbnail-container">
        <div className="react-player" />
        <div className="video-details">
          <div className="avatar" />
          <div className="video-details-text">
            <span className="video-title" />
            <div className="video-tags" />
            <span className="video-date" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default VideoThumbnailSkeleton
